import React from "react";
import {
  CardContent,
  Stack,
  Typography,
  Box,
  Button,
  Switch,
  CircularProgress,
} from "@mui/material";
import {
  CheckCircle as ApproveIcon,
  Cancel as RejectIcon,
  FileUpload as PublishIcon,
} from "@mui/icons-material";
import { SectionCard } from "./StyledComponents";
import BatchSelector from "./BatchSelector";
import QuestionTable from "./QuestionTable";
import QuestionCard from "./QuestionCard";

const StagingTab = ({
  batches,
  selectedBatch,
  selectedBatchConfig,
  batchQuestions,
  batchLoading,
  selectedTempQuestions,
  simpleMode,
  onSimpleModeChange,
  onBatchChange,
  onRefreshBatches,
  onToggleSelection,
  onApprove,
  onReject,
  onPublishSelected,
  filteredSongs,
  songsLoading,
  questionClues,
  selectedSongsForClues,
  generatingClues,
  onBulkSelectSongsForClues,
  onSongsForCluesChange,
  onGenerateClues,
  onRefreshClues,
  onDeleteClue,
}) => {
  return (
    <Stack spacing={3}>
      <BatchSelector
        batches={batches}
        selectedBatch={selectedBatch}
        onBatchChange={onBatchChange}
        onRefresh={onRefreshBatches}
      />

      <SectionCard>
        <CardContent>
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="space-between"
            alignItems="center"
            mb={2}
          >
            <Typography variant="h6" sx={{ color: "#fff" }}>
              Questions in Batch #{selectedBatch}
            </Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Typography variant="body2" sx={{ color: "#ccc" }}>
                  Simple Mode
                </Typography>
                <Switch
                  checked={simpleMode}
                  onChange={(e) => onSimpleModeChange(e.target.checked)}
                  sx={{
                    "& .MuiSwitch-switchBase.Mui-checked": {
                      color: "#4CAF50",
                    },
                    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                      backgroundColor: "#4CAF50",
                    },
                  }}
                />
              </Box>
              <Button
                variant="outlined"
                color="success"
                startIcon={<ApproveIcon />}
                disabled={!selectedTempQuestions.length}
                onClick={() =>
                  selectedTempQuestions.forEach((id) => onApprove(id))
                }
              >
                Approve Selected
              </Button>
              <Button
                variant="outlined"
                color="error"
                startIcon={<RejectIcon />}
                disabled={!selectedTempQuestions.length}
                onClick={() =>
                  selectedTempQuestions.forEach((id) => onReject(id))
                }
              >
                Reject Selected
              </Button>
              <Button
                variant="contained"
                color="primary"
                startIcon={<PublishIcon />}
                disabled={!selectedTempQuestions.length}
                onClick={onPublishSelected}
              >
                Publish Selected
              </Button>
            </Stack>
          </Stack>

          {batchLoading ? (
            <Box display="flex" justifyContent="center" py={4}>
              <CircularProgress />
            </Box>
          ) : simpleMode ? (
            <QuestionTable
              questions={batchQuestions}
              selectedBatchConfig={selectedBatchConfig}
              selectedTempQuestions={selectedTempQuestions}
              questionClues={questionClues}
              onToggleSelection={onToggleSelection}
              onApprove={onApprove}
              onReject={onReject}
            />
          ) : (
            <Box>
              {batchQuestions.map((question) => (
                <QuestionCard
                  key={question.temp_question_id}
                  question={question}
                  selectedBatchConfig={selectedBatchConfig}
                  isSelected={selectedTempQuestions.includes(
                    question.temp_question_id
                  )}
                  onToggleSelection={() =>
                    onToggleSelection(question.temp_question_id)
                  }
                  onApprove={() => onApprove(question.temp_question_id)}
                  onReject={() => onReject(question.temp_question_id)}
                  filteredSongs={filteredSongs}
                  songsLoading={songsLoading}
                  questionClues={questionClues}
                  selectedSongsForClues={selectedSongsForClues}
                  generatingClues={generatingClues}
                  onBulkSelectSongsForClues={onBulkSelectSongsForClues}
                  onSongsForCluesChange={onSongsForCluesChange}
                  onGenerateClues={onGenerateClues}
                  onRefreshClues={onRefreshClues}
                  onDeleteClue={onDeleteClue}
                />
              ))}
            </Box>
          )}
        </CardContent>
      </SectionCard>
    </Stack>
  );
};

export default StagingTab;
